import { defineComponent as _defineComponent } from 'vue'
import { computed, defineAsyncComponent, nextTick, watch } from "vue";
import HaltingAnalysis from "@/components/node/tools/halting-analysis/halting-analysis.vue";
import NetworkVisualNavigator from "@/components/visual-navigator/network-visual-navigator.vue";
import CrawlTime from "@/components/crawl-time.vue";
import Consent from "@/components/consent.vue";
import SimulationBadge from "@/components/simulation-badge.vue";
import TimeTravelBadge from "@/components/time-travel-badge.vue";
import { BAlert } from "bootstrap-vue";
import LazyHydrate from "vue-lazy-hydration";
import useStore from "@/store/useStore";
import { useRoute, useRouter } from "vue-router/composables";
import VueScrollTo from "vue-scrollto";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  props: {
  view: {
    type: String,
    required: true,
    default: "graph",
  },
},
  setup(__props) {

const NetworkAnalysis = defineAsyncComponent(
  () =>
    import("@/components/network/tools/network-analysis/network-analysis.vue")
);



const store = useStore();
const network = store.network;

const route = useRoute();
const router = useRouter();

watch(
  route,
  (to) => {
    if (to.params.publicKey) {
      store.selectedNode = network.getNodeByPublicKey(to.params.publicKey);
      if (!store.selectedNode) {
        router.push({
          name: "network-dashboard",
          query: {
            view: route.query.view,
            network: route.query.network,
            at: route.query.at,
          },
        });
      }
    } else store.selectedNode = undefined;
    if (to.params.organizationId) {
      store.selectedOrganization = network.getOrganizationById(
        to.params.organizationId
      );
      if (!store.selectedOrganization) {
        router.push({
          name: "network-dashboard",
          query: {
            view: route.query.view,
            network: route.query.network,
            at: route.query.at,
          },
        });
      }
    } else store.selectedOrganization = undefined;

    if (to.query.center === "1" || !to.query.center) {
      store.centerNode = store.selectedNode;
    }
  },
  { immediate: true }
);

const selectedNode = computed(() => store.selectedNode);
const selectedOrganization = computed(() => store.selectedOrganization);

const haltingAnalysisPublicKey = computed(() => {
  return store.haltingAnalysisPublicKey;
});

watch(haltingAnalysisPublicKey, (publicKey) => {
  if (publicKey)
    nextTick(() => {
      VueScrollTo.scrollTo("#halting-analysis-card");
    });
});

return { __sfc: true,NetworkAnalysis, store, network, route, router, selectedNode, selectedOrganization, haltingAnalysisPublicKey, HaltingAnalysis, NetworkVisualNavigator, CrawlTime, SimulationBadge, TimeTravelBadge, BAlert, LazyHydrate }
}

})